import React from 'react'

export default function Healthcare() {
  return (
    <div>Healthcare</div>
  )
}
